<!-- PrimeNG Card container -->
<p-card [styleClass]="['cta-card','md:rounded-2xl','overflow-hidden', flat ? 'no-chrome' : 'border']
    .join(' ')" [style.--p-card-background]="flat ? 'transparent' : (outerBgColor || null)"
  [style.borderColor]="flat ? 'transparent' : (borderColor || null)" [ngClass]="{ 'rounded-2xl': !isRaiseMore,
               'rounded-none': isRaiseMore }">


  <div class="w-full md:px-[3.5rem]">
    <div class="w-full container mx-auto ">

      <div class="container max-w-8xl  2xl:max-w-10xl mx-auto mt-8 md:mt-20 " [ngClass]="isRaiseMore
                ? 'mb-0 md:mb-10'
                : 'mb-8 md:mb-20'
              ">

        <div class="relative md:rounded-2xl overflow-hidden "
          [ngStyle]="{ 'background-color': bgColor, 'border-color': borderColor }" [ngClass]="{
                'rounded-2xl': !isRaiseMore,
                'rounded-none': isRaiseMore,
                'border': hasBorder,
                'border-0': !hasBorder
              }">

          <div class="relative grid grid-cols-1 md:grid-cols-2 w-full 2xl:h-[450px]">

            <!-- TEXT COLUMN -->
            <div class="relative z-10 flex flex-col justify-center gap-4 md:rounded-none p-6 md:p-10"
              [ngStyle]="{ 'background-color': bgColor }">
              <h2 class="m-0 font-extrabold leading-tight
               text-[color:var(--p-emphasis-high)]
               text-[30px] lg:text-[36px] text-center md:text-left DMSans" [ngClass]="{ 'md:text-[36px]': !isRaiseMore,
               'md:text-[32px]': isRaiseMore }">
                {{ title }}
              </h2>

              <p *ngIf="!_bodyHtml"
                class="m-0 text-[color:var(--p-emphasis-medium)] text-base md:text-lg !font-noto-serif text-center md:text-left">
                {{ body }}
              </p>
              <p *ngIf="_bodyHtml"
                class="m-0 text-[color:var(--p-emphasis-medium)] text-base md:text-lg text-center md:text-left"
                [innerHTML]="_bodyHtml"></p>
              <!-- Rating row -->
              <div *ngIf="showRating" class="flex w-full justify-center md:justify-start items-center text-center">
                <div class="flex gap-3 mt-1 md:max-w-[360px] ml-20 md:ml-0">
                  <img alt="rating" src="Reviews.svg" />
                </div>
              </div>


              <!-- CTA: href > routerLink > (click) -->
              <div class="mt-2 md:block flex flex-col items-center md:mb-[30px] mb-[16px]">
                <a *ngIf="href" pButton
                  class="font-extrabold rounded-xl !px-[26px] md:min-w-[200px] min-w-[140px] h-9 !font-noto-serif !bg-[var(--community-info-500)] 
                          !border !border-[var(--community-info-500)] "
                  [href]="href" [attr.target]="target" [attr.rel]="target === '_blank' ? rel : null">
                  {{ ctaLabel }}
                </a>

                <a *ngIf="!href && routerLink" pButton
                  class="font-extrabold rounded-xl !px-[26px] md:min-w-[200px] min-w-[140px] h-9 !bg-[var(--p-info-500)]"
                  [routerLink]="routerLink">
                  {{ ctaLabel }}
                </a>

                <button *ngIf="!href && !routerLink" pButton type="button"
                  class="h-9 font-extrabold rounded-xl !px-[26px] md:min-w-[200px] min-w-[140px] !bg-[var(--p-info-500)]"
                  (click)="onCtaClick()">
                  {{ ctaLabel }}
                </button>
              </div>
            </div>

            <!-- IMAGE COLUMN -->
            <div class="relative z-0 min-h-[220px] md:min-h-[320px] hidden md:block">
              <img class="absolute inset-0 w-full h-full object-cover" [src]="imageSrc" [alt]="imageAlt" />

              <!-- gradient scrim at bottom (like your comp) -->
              <div
                class="pointer-events-none absolute inset-x-0 bottom-0 h-[45%] z-[5]
               [background:linear-gradient(to_bottom,rgba(255,255,255,0)_0%,rgba(27,119,85,.08)_45%,rgba(27,119,85,.20)_100%)]">
              </div>
            </div>

            <!-- GAVEL BADGE (overlaps text/image seam) -->
            <div *ngIf="showBadge" class="hidden md:grid place-items-center
         absolute top-1/2 -translate-y-1/2 left-[calc(48.5%-0.75rem)]
         w-[72px] h-[72px] z-20 rounded-full
         -mt-8  /* 4px up; try -mt-0.5 (2px) or -mt-2 (8px) */
         text-[var(--p-primary-color)]">
              <!-- controls icon color -->
              <img src="auction_gavel.svg" class="absolute inset-0 m-auto " />

            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</p-card>